import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=57d031a7&"
import script from "./ArticleList.vue?vue&type=script&lang=ts&"
export * from "./ArticleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports